import { Box, IconButton } from '@material-ui/core'
import { Publish } from '@material-ui/icons'
import styled from 'styled-components'
import { Button } from 'common/atoms/Button/Button'

export const IndustryInputText = styled(Box)`
  color: ${props => props?.theme?.colors?.accent1};
  font-weight: 500;
`
export const StyledEventButton = styled(Button)`
  && {
  }
`

export const StyledUploadIcon = styled(IconButton)`
  && {
    margin-bottom: -1.5em;
    fill: ${props => props.theme.colors.accent};
  }
`

export const DragZoneInput = styled.input`
  display: none;
`

export const StyledText = styled(Box)`
  color: ${props => props.theme.colors.accent1};
`

export const DragZoneLabel = styled.label`
  color: ${props => props.theme.colors.primary};
  padding: 0.5rem 2rem;
  border-radius: 0.3rem;
  cursor: pointer;
  line-height: 0.5em;
`

export const StyledIcon = styled(Publish)`
  && {
    fill: ${props => props.theme.colors.accent};
  }
`
export const StyledPreviewContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.accent1};
  background-color: ${props => props.theme.colors.supplementary};
  padding: 0 10em;
  width: 100%;
  min-width: 60em;
  margin-top: 1em;
`;
